import React, { ChangeEvent, FC, useContext, useCallback } from "react";

import { Input, IInputProps } from "../Input";
import { RadioGroupContext } from "./RadioGroup/RadioGroup";

export type TRadioButtonProps = Omit<IInputProps, "type">;

const RadioButton: FC<TRadioButtonProps> = ({
  id,
  value,
  name: nameProp,
  checked: checkedProp,
  children,
  onChange,
  ...inputProps
}) => {
  const context = useContext(RadioGroupContext);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      context?.onChange?.(event);
      onChange?.(event);
    },
    [context, onChange],
  );

  let checked = checkedProp;
  let name = nameProp;

  if (typeof checked === "undefined") {
    checked = context?.value === value;
  }

  if (typeof name === "undefined") {
    name = context?.name;
  }

  return (
    <Input
      type="radio"
      checked={checked}
      onChange={handleChange}
      name={name}
      value={value}
      id={id}
      data-testid="radio-input"
      {...inputProps}
    />
  );
};

export default RadioButton;
